import { type ReactElement } from 'react';
import { Text } from '@avanta/shared/components/Text';
import { cn } from '@avanta/shared/utils/cn';

interface TableEmptyContentProps {
  className?: string;
  emptyTitle?: string;
  emptyMessage?: string;
}

export const TableEmptyContent = ({
  className,
  emptyTitle,
  emptyMessage,
}: TableEmptyContentProps): ReactElement => (
  <div
    className={cn('flex w-full flex-col items-center justify-center py-12 text-center', className)}
  >
    <div className="flex flex-col items-center gap-2">
      {emptyTitle && (
        <Text tag="h3" variant="text-sm-regular" className="text-denim-500">
          {emptyTitle}
        </Text>
      )}
      {emptyMessage && (
        <Text variant="text-xs-regular" className="text-gray-500">
          {emptyMessage}
        </Text>
      )}
    </div>
  </div>
);
